// PLANO B (roteamento por caminho / single-domain, sem depender de wildcard).
//
// Detecta a loja (tenant) a partir da URL:
//   - query:  ?loja=verdurao
//   - caminho: /t/verdurao/...
// e envia o slug no header 'X-Tenant-Slug' em TODAS as chamadas do axios padrão.
// O backend resolve o banco da loja por esse header (prioridade: subdomínio > header > default).
//
// Obs.: o painel Super Admin usa uma instância axios isolada (axios.create()),
// então NÃO carrega este header — o control plane permanece separado.
import axios from 'axios';

const KEY = 'tenant_slug';
const READY_KEY = 'store_ready';

function detect() {
  try {
    const q = (new URLSearchParams(window.location.search).get('loja') || '').trim().toLowerCase();
    if (q) return q;
    const m = window.location.pathname.match(/^\/t\/([a-z0-9-]+)/i);
    if (m) return m[1].toLowerCase();
  } catch (e) { /* ignore */ }
  return null;
}

export function getTenantSlug() {
  return localStorage.getItem(KEY) || '';
}

export function setTenantSlug(slug) {
  if (!slug) return;
  localStorage.setItem(KEY, slug);
  axios.defaults.headers.common['X-Tenant-Slug'] = slug;
}

export function clearTenantSlug() {
  localStorage.removeItem(KEY);
  delete axios.defaults.headers.common['X-Tenant-Slug'];
}

// --- Telinha de entrada (seleção de loja) ---
// Marca que o usuário já escolheu uma loja (evita reexibir a telinha de entrada).
export function markStoreSelected() {
  localStorage.setItem(READY_KEY, '1');
}

export function hasStoreSelected() {
  return !!localStorage.getItem(READY_KEY) || !!getTenantSlug();
}

// "Trocar de loja": esquece a loja atual e o header, voltando à telinha de entrada.
export function forgetStore() {
  localStorage.removeItem(READY_KEY);
  clearTenantSlug();
}

// Aplica a loja escolhida na telinha de entrada.
// targetSlug = null  -> loja padrão (on-premise), sem header X-Tenant-Slug.
// targetSlug = 'xyz' -> envia X-Tenant-Slug em todas as chamadas.
export function selectStore(targetSlug) {
  if (targetSlug) {
    setTenantSlug(targetSlug);
  } else {
    clearTenantSlug();
  }
  markStoreSelected();
}

// init (uma vez, no carregamento do app)
(function initTenant() {
  const detected = detect();
  if (detected) {
    setTenantSlug(detected);
  } else {
    const stored = getTenantSlug();
    if (stored) axios.defaults.headers.common['X-Tenant-Slug'] = stored;
  }
})();
